export const SETTINGS = {
  ROUNDS_LIMIT: 5,
  TRACKS_LIMIT: 8,
  CHOICES_TIMEOUT: 10 * 1000,
  CHOICES_STARTUP: 1 * 1000,
  RESULTS_TIMEOUT: 3 * 1000,
  GUESS_ATTEMPTS: 0,
};

